import { ApiRefEditor } from './api';
import MSG from '@/services/notify';
export const EditorRefs = {

  async getRefs(refNamesArray, ctx) {

    const refs = {};

    await Promise.all(
      refNamesArray.map(async r => {
        const ref = await ApiRefEditor.get(r);
        if (ref.error) {
          MSG.error(ref.error, ctx);
          refs[r] = [];
        } else {
          refs[r] = ref.data;
        }
      }),
    );

    return refs;
  },

  /**
     *
     * @param ref { Array }
     * @param param  {String}
     * @param value { String, Number }
     */
  findElement(ref, param, value) {
    const finded = ref.find(r => r[param] === value);

    if (finded) {
      return finded;
    } else {
      return null;
    }


  }


};
